import React from 'react'
import { default as Container } from '../container'
import { default as Content } from './content'
import { Helmet } from 'react-helmet'

const Page = () => {
  return (
    <Container active={0}>
      <Helmet>
        <title>Gestion responsable del medio ambiente | Prima AFP</title>
        <meta name='title' content='Gestion responsable del medio ambiente | Prima AFP' data-react-helmet="true" />
        <meta name='description' content='Enterate aquí sobre las actividades de responsabilidad social relacionadas al medio ambiente de las que Prima AFP forma parte.' data-react-helmet="true" />
        <link rel="next" href="https://www.prima.com.pe/public-zone/sobre-prima-afp/responsabilidad-social/gestion-responsable-con-el-medio-ambiente/" />
      </Helmet>

      <Content />
    </Container>
  )
}

export default Page
